import { ChangeDetectorRef, Component, inject, signal } from '@angular/core';
import { ReportService } from '../../services/report.service';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { distinctUntilChanged } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Loader } from '../../loader/loader';
import { MatIconModule } from '@angular/material/icon';
import { AddReportRequest, ReportStatus } from '../../models/report';
import { SnackbarService } from '../../services/snackbar.service';
import { ReportSharedService } from '../../services/report-shared';
import { ValidationMessagesTexts } from '../../constants/validation-messages.constants';
import { ApiResponseMessages } from '../../constants/api-response-messages.constants';
import { NumbersOnlyDirective } from '../../directives/numbers-only';
import { MonthPickerComponent } from '../../components/month-picker/month-picker';
import { SearchableDropdown } from '../../components/searchable-dropdown/searchable-dropdown';


@Component({
  selector: 'app-generate-report',
  standalone: true,
  imports: [FormsModule, CommonModule, ReactiveFormsModule, Loader, MatIconModule, NumbersOnlyDirective,MonthPickerComponent,SearchableDropdown],
  templateUrl: './generate-report.html',
  styleUrl: './generate-report.scss',
})
export class GenerateReport {
  constructor(private router: Router, private cd: ChangeDetectorRef) { }
  private fb = inject(FormBuilder);
  private reportService = inject(ReportService);
  private snackbar = inject(SnackbarService);
  private reportSharedService = inject(ReportSharedService);

  options: FormGroup = this.fb.group({
    reportType: ['', Validators.required],
    projectID: ['', Validators.required],
    clientName: ['', Validators.required],
    reportName: ['', Validators.required],
    reportMonth: ['', Validators.required],
    sitelocationname: ['', Validators.required],
    additionalNotes: [''],
    stateName: ['', Validators.required]
  });
  isLoading = false;
  reportTypes = this.reportService.getReportTypes();
  clients = this.reportService.getClients();
  satates = this.reportService.getStates();
  locations = this.reportService.getLocations();
  step = signal(2);
  reportData: any;
  validationMessages = ValidationMessagesTexts;
  apiResponseMessages = ApiResponseMessages;

  setStep(newStep: number) {
    this.step.set(newStep);
  }
  ngOnInit() {
    document.documentElement.style.overflow = 'auto';
    document.body.style.overflow = 'auto';

    this.options.get('clientName')?.valueChanges.pipe(distinctUntilChanged()).subscribe((clientId) => {
      if (clientId) {
        this.reportService.loadReportTypes(clientId);
        this.reportService.loadStates(clientId);
        this.reportService.loadLocations(clientId);
      }
    });

    this.reportData = this.reportSharedService.getFormData();

    if (this.reportData) {
      this.options.patchValue({
        reportType: this.reportData.reportType,
        projectID: this.reportData.projectID,
        clientName: this.reportData.clientName,
        sitelocationname: this.reportData.sitelocationname,
        stateName: this.reportData.stateName
      });
      
    }
  }

  ngOnDestroy(): void {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }


  addInitilaReportData() {
    this.options.markAllAsTouched();
    if (this.options.invalid) return;
    const formData = this.options.value;
    if(this.reportData === null) {
      this.snackbar.showCustom({
        type: 'error',
        title: this.validationMessages.TOASTER.ERROR.TITLE,
        message: this.validationMessages.CREATE_GENERATE_REPORT.MISSING_FILE_ID_OR_REFERENCE_PATH,
      });
      return;
    }
    const request: AddReportRequest = {
      reportName: formData.reportName,
      clientId: formData.clientName,
      projectId: formData.projectID,
      additionalNotes: formData.additionalNotes,
      reportTypeId: formData.reportType,
      locationId: formData.sitelocationname,
      status: ReportStatus.Initiated,
      reportMonth: formData.reportMonth,
      stateId: formData.stateName,
      fileId: this.reportData.fileId,
      referencePath: this.reportData.referencePath
    };
    this.isLoading = true;
    this.reportService.addInitialReportData(request).subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response.success) {
          this.router.navigate(['/report-sections'], {
            state: {
              data: response.data,
              initialGenerate: true,
              projectName: request.reportName,
              reportData: formData,
            },
          });
        }
        else {
          this.snackbar.showCustom({
            type: 'error',
            title: this.validationMessages.TOASTER.ERROR.TITLE,
            message: response.message,
          });
        }
      }, error: (err) => {
        this.snackbar.showCustom({
          type: 'error',
          title: this.validationMessages.TOASTER.ERROR.TITLE,
          message: this.validationMessages.TOASTER.ERROR.SOMETHING_WENT_WRONG,
        });
        this.isLoading = false;
      },
    });
  }

  onCancel() {
    this.router.navigate(['/reports']);
  }
}
